import React from 'react';
import { Section } from '../ui/Section';
import { BookOpen, Moon, Droplets, Zap, Sun } from 'lucide-react';
export function WhatInsideSection() {
  const protocols = [{
    num: '01',
    icon: <Moon className="h-6 w-6" data-id="element-128" />,
    title: 'The 3-Hour Buffer',
    desc: 'Why your 7:00 PM dinner is causing your 3:00 AM anxiety — and the exact cutoff time to prevent it.'
  }, {
    num: '02',
    icon: <Droplets className="h-6 w-6" data-id="element-129" />,
    title: 'The Thermal Drop',
    desc: 'How a simple shower at the right time triggers a massive release of natural sleep hormones.'
  }, {
    num: '03',
    icon: <Zap className="h-6 w-6" data-id="element-130" />,
    title: 'The 3:00 AM Panic Button',
    desc: "The 'Salt & Honey' trick to fall back asleep in under 5 minutes when you wake mid-night."
  }, {
    num: '04',
    icon: <Sun className="h-6 w-6" data-id="element-131" />,
    title: 'The Sunlight Anchor',
    desc: "The 10-minute morning habit that biologically guarantees tonight's sleep."
  }];
  return <Section background="surface" data-id="element-132">
      <div className="text-center mb-12" data-id="element-133">
        <p className="text-brand-amber text-xs font-semibold uppercase tracking-[0.2em] mb-3" data-id="element-134">
          Inside the 40-Page Blueprint
        </p>
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-cream mb-4" data-id="element-135">
          Four Protocols. One Complete Reset.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-136">
        {protocols.map(p => <div key={p.num} className="bg-brand-night border border-brand-border rounded-xl p-6 hover:border-brand-amber/40 transition-colors duration-300" data-id="element-137">
            <div className="flex items-start gap-4" data-id="element-138">
              <div className="flex-shrink-0" data-id="element-139">
                <span className="text-brand-amber/30 font-serif font-bold text-3xl leading-none" data-id="element-140">
                  {p.num}
                </span>
              </div>
              <div data-id="element-141">
                <div className="flex items-center gap-2 mb-2" data-id="element-142">
                  <span className="text-brand-amber" data-id="element-143">{p.icon}</span>
                  <h4 className="font-bold text-brand-cream text-lg" data-id="element-144">
                    {p.title}
                  </h4>
                </div>
                <p className="text-brand-muted text-sm leading-relaxed" data-id="element-145">
                  {p.desc}
                </p>
              </div>
            </div>
          </div>)}
      </div>

      {/* Book mockup */}
      <div className="flex justify-center" data-id="element-146">
        <div className="relative w-48 aspect-[3/4] bg-brand-night border border-brand-amber/30 rounded-lg shadow-amber flex items-center justify-center p-6 transform -rotate-1" data-id="element-147">
          <div className="text-center border border-brand-amber/20 p-4 h-full w-full flex flex-col justify-center items-center rounded" data-id="element-148">
            <BookOpen className="h-8 w-8 text-brand-amber mb-3" data-id="element-149" />
            <p className="font-serif font-bold text-brand-cream text-sm mb-1" data-id="element-150">
              The Deep Sleep
            </p>
            <p className="font-sans font-light text-brand-amber text-xs uppercase tracking-widest mb-4" data-id="element-151">
              Cortisol Reset
            </p>
            <div className="w-8 h-px bg-brand-amber/50 mb-4" data-id="element-152"></div>
            <p className="text-xs text-brand-muted" data-id="element-153">Official Blueprint</p>
          </div>
          <div className="absolute -top-3 -right-3 bg-brand-amber text-brand-night font-bold rounded-full w-14 h-14 flex items-center justify-center shadow-lg text-sm rotate-12" data-id="element-154">
            $6,39
          </div>
        </div>
      </div>
    </Section>;
}